import { type TypedDocumentNode, useQuery } from '@apollo/client';
import type { CommodityAttributesQuery, CommodityAttributesQueryVariables } from 'types/graphql';

/**
 * The catalog's change signal: every catalog write refetches it, and `CommoditiesGrid` refreshes on each
 * completed refetch. It reads one count, not the commodity list (TAS-3660 NN07); the grid's rows come
 * from the paged catalog queries.
 */
export const COMMODITY_CATALOG_QUERY = gql`
  query CommodityCatalogQuery {
    commodityPage(input: { first: 1 }) {
      totalCount
    }
  }
`;

/** One commodity's varieties, pack styles, units and labels, for the product drawer's attribute fields. */
export const COMMODITY_ATTRIBUTES_QUERY: TypedDocumentNode<
  CommodityAttributesQuery,
  CommodityAttributesQueryVariables
> = gql`
  query CommodityAttributesQuery($id: Int!) {
    commodity(id: $id) {
      id
      name
      styles {
        id
        name
      }
      sizes {
        id
        name
      }
      units {
        id
        name
      }
      labels {
        id
        name
      }
    }
  }
`;

/** The selected commodity's attributes; nothing is read until a commodity is chosen. */
export function useCommodityAttributes(commodityId: number | null) {
  return useQuery(COMMODITY_ATTRIBUTES_QUERY, { variables: { id: commodityId ?? 0 }, skip: commodityId === null });
}
